import { Box, Button, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { Fragment } from 'react/jsx-runtime';
import { closeDialog } from '../../../store/dialog/dialog.action';
import {
    changeNodeStatusStart,
    getMyNodesStart,
} from '../../../store/node/node.action';
import {
    FlexBoxFullWHColumn,
    FlexBoxFullWRowBetween,
} from '../../layout/layout.styles';
import DialogContent from '../../ui/dialog-content/dialog-content.component';
import DialogTitle from '../../ui/dialog-title/dialog-title.component';
import {
    NextStepIcon,
    NextStepNodeTextBox,
    NextStepText,
    TextAreaNextStepLabel,
} from './dialog-next-step.styles';

import { useState } from 'react';
import { CustomScroll } from 'react-custom-scroll';
import { ReactComponent as PhaseIcon } from '../../../assets/icons/phase-icon.svg';
import { ReactComponent as SubphaseIcon } from '../../../assets/icons/subphase-icon.svg';
import { ReactComponent as TaskIcon } from '../../../assets/icons/task-icon.svg';
import { NextStep, Node } from '../../../models/models';
import { setIsError } from '../../../store/error/error.action';
import {
    clearNodeProjectSelected,
    getProjectStart,
} from '../../../store/project/project.action';
import { selectProjectSelected } from '../../../store/project/project.selector';

const DialogNextStep = ({ inputData }: { inputData: any }) => {
    const node: Node = inputData.node;

    const projectSelected = useSelector(selectProjectSelected);
    const [nextStepsSelected, setNextStepsSelected] = useState<number[]>([]);

    const dispatch = useDispatch();

    const handleNextStepClick = (stepId: number) => {
        if (nextStepsSelected.includes(stepId)) {
            setNextStepsSelected(
                nextStepsSelected.filter((id) => id !== stepId)
            );
        } else {
            setNextStepsSelected([...nextStepsSelected, stepId]);
        }
    };

    const handleCompleteConfirm = () => {
        const status = 'done';
        if (node.next_steps_required && nextStepsSelected.length === 0) {
            dispatch(setIsError(true, 'Seleziona almeno uno step'));
            return;
        }
        dispatch(
            changeNodeStatusStart(node.id, status, nextStepsSelected, () => {
                dispatch(closeDialog());
                dispatch(clearNodeProjectSelected());
                dispatch(
                    getMyNodesStart(projectSelected ? projectSelected.id : null)
                );
                if (projectSelected) {
                    dispatch(getProjectStart(projectSelected.id, null));
                }
            })
        );
    };

    return (
        <Fragment>
            <DialogTitle title="Seleziona Step Successivi" />
            <DialogContent height="100vh">
                <FlexBoxFullWHColumn>
                    <TextAreaNextStepLabel style={{ marginBottom: '8px' }}>
                        STEP DISPONIBILI{' '}
                        {node.next_steps_required
                            ? '(sceglierne almeno uno)'
                            : '(scelta facoltativa)'}
                    </TextAreaNextStepLabel>
                    <Box my={1} />

                    <NextStepNodeTextBox>
                        <CustomScroll
                            heightRelativeToParent="100%"
                            className="custom-scroll"
                        >
                            <Box
                                display={'flex'}
                                flexDirection={'column'}
                                pr={'10px'}
                                gap={2}
                            >
                                {node.next_steps.length > 0 ? (
                                    node.next_steps.map((step: NextStep) => (
                                        <FlexBoxFullWRowBetween
                                            key={step.id}
                                            onClick={() =>
                                                handleNextStepClick(step.id)
                                            }
                                            minHeight={120}
                                            alignItems={'center'}
                                            px={(theme) => theme.spacing(2)}
                                            py={(theme) => theme.spacing(1)}
                                            borderRadius={'12px'}
                                            sx={{
                                                cursor: 'pointer',
                                                background:
                                                    nextStepsSelected.includes(
                                                        step.id
                                                    )
                                                        ? 'linear-gradient(210deg, rgba(83, 97, 220, 1) 8.33%, rgba(89, 184, 190, 1) 125.21%)'
                                                        : 'linear-gradient(210deg, rgba(83, 97, 220, 0.40) 8.33%, rgba(89, 184, 190, 0.40) 125.21%)',
                                            }}
                                        >
                                            <Box
                                                display={'flex'}
                                                gap={2}
                                                alignItems={'center'}
                                                width={'10%'}
                                                pr={2}
                                            >
                                                <NextStepIcon>
                                                    {step.next_node_type ===
                                                        'phase' && (
                                                        <PhaseIcon />
                                                    )}
                                                    {step.next_node_type ===
                                                        'subphase' && (
                                                        <SubphaseIcon />
                                                    )}
                                                    {step.next_node_type ===
                                                        'task' && <TaskIcon />}
                                                </NextStepIcon>
                                            </Box>
                                            <Box width={'50%'} pr={2}>
                                                <NextStepText>
                                                    {step.next_node_name}
                                                </NextStepText>
                                            </Box>
                                            <Box width={'40%'} pr={2}>
                                                <NextStepText>
                                                    {step.comment}
                                                </NextStepText>
                                            </Box>
                                        </FlexBoxFullWRowBetween>
                                    ))
                                ) : (
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        height="100%"
                                        textAlign="center"
                                        width="100%"
                                    >
                                        <Typography>
                                            {' '}
                                            Nessun altro step disponibile.
                                            <br />
                                            Clicca conferma per completare
                                            l'operazione.
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                        </CustomScroll>
                    </NextStepNodeTextBox>
                    <Box my={1} />
                    <Box display="flex" justifyContent="flex-end">
                        <Button
                            onClick={handleCompleteConfirm}
                            style={{
                                borderRadius: '15px',
                                background: '#59B8CA',
                                width: '220px',
                                height: '40px',
                                flexShrink: 0,
                                color: '#2C375A',
                                border: 'none',
                                cursor: 'pointer',
                                fontWeight: 'bold',
                                fontSize: '14px',
                            }}
                        >
                            CONFERMA
                        </Button>
                    </Box>
                </FlexBoxFullWHColumn>
            </DialogContent>
        </Fragment>
    );
};

export default DialogNextStep;
